import { render, staticRenderFns } from "./LogoWhite.vue?vue&type=template&id=9ecdc1ca&scoped=true&"
var script = {}
import style0 from "./LogoWhite.vue?vue&type=style&index=0&id=9ecdc1ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecdc1ca",
  null
  
)

export default component.exports